export const USER_META_SUCCESS = 'user_meta_success';
export const USER_META_FAIL = 'user_meta_fail';
export const USER_META_PENDING = 'user_meta_pending';
